import React, { useRef, useState } from 'react';
import { Form, Row, Col, Typography, useProTableOt    } from "../../ui/ot";
import { useTranslation } from 'react-i18next';
import HolidayDetailOverview from '../../shift_management/holiday_detail_overview'
const HolidayDetailManagement = () => {

    return (<Row>
        <Col span={24}>
            <HolidayDetailOverview
                propsHolidaySettingApi = "/reservation_registration_and_space_management/backend/holiday"
                propsSearchparams 
            />
        </Col>
    </Row>)
}
export default HolidayDetailManagement